const arrowOptions = { arrows: { to: { enabled: false } } };

const edgeOptions = {
  color: { color: '#407DE1', highlight: '#E2706C' },
  length: 250,
};

const mostActiveNodeOptions = {
  color: {
    background: '#E2706C',
    highlight: { background: '#f78484', border: '#f66' },
  },
  size: 45,
};

const getEdgeOutboundCount = (edge, edges) => {
  const { length: count } = edges.filter(
    edgeValue => edgeValue.from === edge.from && edgeValue.to === edge.to,
  );

  return count;
};

const getEdgeInboundCount = (edge, edges) => {
  const { length: count } = edges.filter(
    edgeValue => edgeValue.from === edge.to && edgeValue.to === edge.from,
  );

  return count;
};

const getNodeTitle = metadata => {
  let title = '';

  if (metadata.attributes.name)
    title += `Name: ${metadata.attributes.name}<br />`;

  if (metadata.attributes.email)
    title += `Email: ${metadata.attributes.email}<br />`;

  if (metadata.attributes.phone)
    title += `Phone: ${metadata.attributes.phone}<br />`;

  if (metadata.type) {
    title += `Type: ${metadata.type}<br />`;
  }

  if (metadata.attributes.tz)
    title += `Timezone: ${metadata.attributes.tz}<br />`;

  if (metadata.attributes.sso_profile_id)
    title += `SSO profile id: ${metadata.attributes.sso_profile_id}<br />`;

  if (metadata.attributes.created_at)
    title += `Created at: ${metadata.attributes.created_at}<br />`;

  if (metadata.attributes.updated_at)
    title += `Updated at: ${metadata.attributes.updated_at}<br />`;

  return title;
};

export const getNodeLabel = metadata =>
  metadata.attributes.name || metadata.attributes.email;

const mapNodesData = nodes =>
  nodes.map(node => ({
    ...node,
    title: getNodeTitle(node.metadata),
    label: getNodeLabel(node.metadata),
    size: 35,
    // value: calculateNodeValue(node.id, edges),
  }));

const getEdgeTitle = (edge, edges) => {
  let title = '';

  const fromCount = getEdgeOutboundCount(edge, edges);
  const toCount = getEdgeInboundCount(edge, edges);
  const totalCount = fromCount + toCount;

  title += `From: ${fromCount} ${fromCount > 1 ? 'contacts' : 'contact'}<br />`;
  title += `To: ${toCount} ${toCount > 1 ? 'contacts' : 'contact'}<br />`;
  title += `Total: ${totalCount} ${
    totalCount > 1 ? 'contacts' : 'contact'
  }<br />`;

  return title;
};

const getEdgeValue = (edge, edges) => {
  const fromCount = getEdgeOutboundCount(edge, edges);
  const toCount = getEdgeInboundCount(edge, edges);

  return fromCount + toCount;
};

const mapEdgesData = edges =>
  edges.map(edge => ({
    ...edge,
    ...arrowOptions,
    ...edgeOptions,
    title: getEdgeTitle(edge, edges),
    value: getEdgeValue(edge, edges),
  }));

const markMostActiveNodes = (nodes, maxDegreeParticipants) => {
  return nodes.map(node => ({
    ...node,
    ...(maxDegreeParticipants.includes(node.id) ? mostActiveNodeOptions : {}),
  }));
};

export const mapDataToGraphOptions = (nodes, edges, maxDegreeParticipants) => ({
  nodes: markMostActiveNodes(mapNodesData(nodes, edges), maxDegreeParticipants),
  edges: mapEdgesData(edges),
});

export const mockGraph = {
  nodes: [
    { id: 1, value: 2, label: 'Algie' },
    { id: 2, value: 31, label: 'Alston' },
    { id: 3, value: 12, label: 'Barney' },
    { id: 4, value: 16, label: 'Coley' },
    { id: 5, value: 17, label: 'Grant' },
    { id: 6, value: 15, label: 'Langdon' },
    { id: 7, value: 6, label: 'Lee' },
    { id: 8, value: 5, label: 'Merlin' },
    { id: 9, value: 30, label: 'Mick' },
    { id: 10, value: 18, label: 'Tod' },
  ],
  edges: [
    {
      from: 2,
      to: 8,
      value: 3,
      title: 'From: 2 contacts<br>To: 3 contacts<br>Total: 5 contacts',
      ...arrowOptions,
      ...edgeOptions,
    },
    {
      from: 2,
      to: 9,
      value: 5,
      title: 'From: 2 contacts<br>To: 3 contacts<br>Total: 5 contacts',
      ...arrowOptions,
      ...edgeOptions,
    },
    {
      from: 2,
      to: 10,
      value: 1,
      title: 'From: 2 contacts<br>To: 3 contacts<br>Total: 5 contacts',
      ...arrowOptions,
      ...edgeOptions,
    },
    {
      from: 4,
      to: 6,
      value: 8,
      title: 'From: 2 contacts<br>To: 3 contacts<br>Total: 5 contacts',
      ...arrowOptions,
      ...edgeOptions,
    },
    {
      from: 5,
      to: 7,
      value: 2,
      title: 'From: 2 contacts<br>To: 3 contacts<br>Total: 5 contacts',
      ...arrowOptions,
      ...edgeOptions,
    },
    {
      from: 4,
      to: 5,
      value: 1,
      title: 'From: 2 contacts<br>To: 3 contacts<br>Total: 5 contacts',
      ...arrowOptions,
      ...edgeOptions,
    },
    {
      from: 9,
      to: 10,
      value: 2,
      title: 'From: 2 contacts<br>To: 3 contacts<br>Total: 5 contacts',
      ...arrowOptions,
      ...edgeOptions,
    },
    {
      from: 2,
      to: 3,
      value: 6,
      title: 'From: 2 contacts<br>To: 3 contacts<br>Total: 5 contacts',
      ...arrowOptions,
      ...edgeOptions,
    },
    {
      from: 3,
      to: 9,
      value: 4,
      title: 'From: 2 contacts<br>To: 3 contacts<br>Total: 5 contacts',
      ...arrowOptions,
      ...edgeOptions,
    },
    {
      from: 5,
      to: 3,
      value: 1,
      title: 'From: 2 contacts<br>To: 3 contacts<br>Total: 5 contacts',
      ...arrowOptions,
      ...edgeOptions,
    },
    {
      from: 2,
      to: 7,
      value: 4,
      title: 'From: 2 contacts<br>To: 3 contacts<br>Total: 5 contacts',
      ...arrowOptions,
      ...edgeOptions,
    },
  ],
};
